import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
export var MessageRow = function (_React$Component) {
  _inherits(MessageRow, _React$Component);

  var _super = _createSuper(MessageRow);

  function MessageRow() {
    _classCallCheck(this, MessageRow);

    return _super.apply(this, arguments);
  }

  _createClass(MessageRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onRender) this.props.onRender(this);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "col-md-10 messagecontainer ".concat(this.props.messageFrom == 'You' ? "darker" : "")
      }, React.createElement("p", null, this.props.message), React.createElement("span", {
        className: "".concat(this.props.messageFrom == 'You' ? "time-right" : "time-left")
      }, this.props.messageFrom));
    }
  }]);

  return MessageRow;
}(React.Component);